import request from '@/utils/request';

/**
 * @description 查询技师绑定服务列表
 */
function queryStaffBindServiceList({ kdtId = '', itemTags, pageNum, pageSize } = {}) {
  return request({
    url: 'technician/service/pageQueryPositionRankList',
    method: 'get',
    params: {
      itemTags,
      pageNum,
      pageSize
    },
    kdtId,
    isKdtId: true
  });
}

/**
 * @description 查询服务标签列表
 */
function queryServiceTagList({ itemTag = '' } = {}) {
  return request({
    url: 'technician/service/queryItemTagList',
    method: 'get',
    params: { itemTag },
    isKdtId: true
  });
}

/**
 * @description 技师(职级)绑定服务标签
 */
function staffBindServiceTags({ kdtId, positionRankId, itemTags } = {}) {
  return request({
    url: 'technician/service/bindPositionRankAndItemTag',
    method: 'post',
    data: {
      positionRankId,
      itemTags
    },
    kdtId,
    isKdtId: true
  });
}

/**
 * @description 查询职级关联的技师列表
 */
function queryRankBindStaffList({ kdtId, positionRankId, pageNum, pageSize } = {}) {
  return request({
    url: 'technician/service/pageQueryAssociatedTechnician',
    method: 'get',
    params: {
      positionRankId,
      pageNum,
      pageSize
    },
    kdtId,
    isKdtId: true
  });
}

export default {
  queryStaffBindServiceList,
  queryServiceTagList,
  staffBindServiceTags,
  queryRankBindStaffList,
};
